import _ from "lodash";
export const ENV = process.env.REACT_APP_ENV || "local";
export const adminNavigation = {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fas fa-tachometer-alt",
      badge: {
        variant: "info",
        text: "NEW"
      },
      children: [
        {
          name: "Dashboard",
          url: "/dashboard",
          icon: "fas fa-tachometer-alt"
        },
        {
          name: "Analysis",
          url: "/dashboard/analysis",
          icon: "fas fa-chart-bar"
        }
      ]
    },
    {
      name: "Sale KPI",
      url: "/kpi/dashboard",
      icon: "icon-speedometer",
      children: [
        {
          name: "Dashboard",
          url: "/kpi/dashboard",
          icon: "icon-speedometer"
        },
        {
          name: "Customers Report",
          url: "/kpi/followup",
          icon: "fas fa-snowman"
        },
        {
          name: "Request Cars",
          url: "/kpi/request-cars",
          icon: "fas fa-handshake"
        }
      ]
    },
    {
      name: "Negotiation List",
      url: "/inquiries",
      icon: "far fa-comment-dots"
    },
    {
      name: "Order List",
      url: "/orders/all?type=order",
      icon: "fas fa-money-check-alt",
      children: [
        {
          name: "All",
          url: "/orders/all?type=order",
          icon: "fas fa-shopping-cart"
        },
        {
          name: "Issued Invoice",
          url: "/orders/issued?step=2&step=3&step=4&step=5&step=6&step=7&step=8",
          icon: "fas fa-file-invoice"
        },
        {
          name: "Confirmed T/T Copy",
          url: "/orders/confirmed-tt?step=3&step=4&step=5&step=6&step=7&step=8",
          icon: "fas fa-money-check"
        },
        {
          name: "Confirmed Payment",
          url: "/orders/confirmed-payment?step=4&step=5&step=6&step=7&step=8",
          icon: "fas fa-file-invoice-dollar"
        },
        {
          name: "Shared Shipping Schedule",
          url: "/orders/shared-shipping?step=5&step=6&step=7&step=8",
          icon: "fas fa-shipping-fast"
        },
        {
          name: "Shared BL Copy",
          url: "/orders/sharedbl?step=6&step=7&step=8",
          icon: "fas fa-money-check-alt"
        },
        {
          name: "Sent Original Documents",
          url: "/orders/sent-docs?step=7&step=8",
          icon: "fas fa-file-signature"
        },
        {
          name: "Car Received",
          url: "/orders/car-received?step=8",
          icon: "fas fa-car"
        }
      ]
    },
    {
      name: "Confirm Payment",
      url: "/confirm/payment?step=2&step=3&step=4&step=5&step=6&step=7&step=8",
      icon: "fas fa-hand-holding-usd"
    },
    {
      name: "Release Money",
      url: "/money/release?step=4&step=5&step=6&step=7&step=8",
      icon: "fas fa-hand-holding-usd"
    },
    {
      name: "Car",
      url: "/cars",
      icon: "fas fa-car",
      children: [
        {
          name: "Car List",
          url: "/cars",
          icon: "fas fa-car"
        },
        {
          name: "Add Car",
          url: "/cars/add",
          icon: "fas fa-car-battery"
        },
        {
          name: "Import/Export",
          url: "/csvs",
          icon: "fas fa-file-import"
        }
      ]
    },
    {
      title: true,
      name: "CFJ"
    },
    {
      name: "Company",
      url: "/companies",
      icon: "fa fa-building",
      children: [
        {
          name: "Company List",
          url: "/companies",
          icon: "fas fa-list"
        },
        {
          name: "Create Company",
          url: "/company",
          icon: "fas fa-folder-plus"
        }
      ]
    },
    {
      name: "Manipulated",
      url: "/manipulated-company",
      icon: "fas fa-igloo"
    },
    {
      name: "Users",
      url: "/users",
      icon: "fas fa-user",
      children: [
        {
          name: "List",
          url: "/users",
          icon: "fas fa-list"
        },
        {
          name: "Add",
          url: "/user",
          icon: "fas fa-folder-plus"
        }
      ]
    },
    {
      name: "Referral Campaign",
      url: "/referral-campaign",
      icon: "fas fa-tags",
      children: [
        {
          name: "Introducers",
          url: "/introducers",
          icon: "fas fa-user-tie"
        },
        {
          name: "Buyers",
          url: "/buyers",
          icon: "fas fa-users"
        },
        {
          name: "Withdrawal Requests",
          url: "/withdrawal-requests",
          icon: "fas fa-university"
        },
        {
          name: "Using Requests",
          url: "/using-requests",
          icon: "fas fa-money-bill-wave"
        },
        {
          name: "Campaigns",
          url: "/campaigns",
          icon: "fas fa-money-bill-wave"
        }
      ]
    },
    {
      name: "Coupon",
      url: "/coupon",
      icon: "fas fa-percent"
    },
    {
      name: "Tags",
      url: "/sale-tags",
      icon: "fas fa-tags"
    },
    {
      name: "Shipping Agents",
      url: "/shipping-agents",
      icon: "fas fa-ship"
    },
    {
      name: "Shipping Delay Notes",
      url: "/shipping-delay-notes",
      icon: "fas fa-exclamation-triangle"
    },
    {
      name: "Gallery",
      url: "/galleries",
      icon: "fas fa-images"
    },
    {
      name: "Local Pages",
      url: "/local-page-management",
      icon: "icon-globe"
    },
    {
      name: "Testimonials",
      url: "/testimonials",
      icon: "fas fa-smile"
    },
    {
      name: "Billing",
      url: "/billing",
      icon: "fas fa-dollar-sign"
    },
    {
      name: "Macros",
      url: "/macros",
      icon: "fas fa-file"
    },
    {
      name: "Auto Reply",
      url: "/auto-reply",
      icon: "fas fa-reply-all"
    },
    {
      name: "Freight",
      url: "/freight",
      icon: "fas fa-truck-loading"
    },
    {
      name: "Ads Manager",
      url: "/ads",
      icon: "fas fa-ad"
    },
    {
      name: "Landing Tags",
      url: "/tags",
      icon: "fas fa-tags"
    },
    {
      name: "Configurations",
      url: "/car-service",
      icon: "fas fa-wrench",
      children: [
        {
          name: "Car Service",
          url: "/car-service",
          icon: "fas fa-list"
        }
      ]
    },
    {
      name: "SEO",
      url: "/boxtext",
      icon: "fas fa-envelope-open-text",
      children: [
        {
          name: "Boxtext",
          url: "/boxtext",
          icon: "fas fa-envelope-open-text"
        },
        {
          name: "Meta",
          url: "/meta",
          icon: "fas fa-envelope-open-text"
        },
        {
          name: "Boxlink",
          url: "/boxlink",
          icon: "fas fa-envelope-open-text"
        },
        {
          name: "FAQ",
          url: "/faq",
          icon: "fas fa-envelope-open-text"
        }
      ]
    },
    {
      title: true,
      name: "Master Data"
    },
    {
      name: "Order Management",
      url: "/order-management-confirmed",
      icon: "fas fa-tasks"
    },
    {
      name: "Models",
      url: "/models",
      icon: "fa fa-tape"
    },
    {
      name: "AutoFill",
      url: "/modelspecs",
      icon: "fa fa-magic"
    },
    {
      name: "Regulations",
      url: "/regulations",
      icon: "fa fa-pencil-ruler"
    },
    {
      name: "Transformations",
      url: "/transformations",
      icon: "fa fa-hat-wizard"
    },
    {
      name: "System Guidelines",
      url: "/system-guidelines",
      icon: "fab fa-guilded"
    }
  ]
};
export const navigation = {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fas fa-tachometer-alt",
      badge: {
        variant: "info",
        text: "NEW"
      },
      children: [
        {
          name: "Dashboard",
          url: "/dashboard",
          icon: "fas fa-tachometer-alt"
        },
        {
          name: "Analysis",
          url: "/dashboard/analysis",
          icon: "fas fa-chart-bar"
        }
      ]
    },
    {
      name: "Car",
      url: "/cars",
      icon: "fas fa-car",
      children: [
        {
          name: "Car List",
          url: "/cars",
          icon: "fas fa-car"
        },
        {
          name: "Add Car",
          url: "/cars/add",
          icon: "fas fa-car-battery"
        },
        {
          name: "Import/Export",
          url: "/csvs",
          icon: "fas fa-file-import"
        }
      ]
    },
    {
      name: "Company",
      url: "/companies",
      icon: "fa fa-building",
      children: [
        {
          name: "Company List",
          url: "/companies",
          icon: "fas fa-list"
        }
      ]
    },
    {
      name: "Negotiation List",
      url: "/inquiries",
      icon: "fas fa-money-check-alt"
    },
    {
      name: "Order List",
      url: "/orders/all?type=order",
      icon: "fas fa-money-check-alt",
      children: [
        {
          name: "All",
          url: "/orders/all?type=order",
          icon: "fas fa-shopping-cart"
        },
        {
          name: "Issued Invoice",
          url: "/orders/issued?step=2&step=3&step=4&step=5&step=6&step=7&step=8",
          icon: "fas fa-file-invoice"
        },
        {
          name: "Confirmed T/T Copy",
          url: "/orders/confirmed-tt?step=3&step=4&step=5&step=6&step=7&step=8",
          icon: "fas fa-money-check"
        },
        {
          name: "Confirmed Payment",
          url: "/orders/confirmed-payment?step=4&step=5&step=6&step=7&step=8",
          icon: "fas fa-file-invoice-dollar"
        },
        {
          name: "Shared Shipping Schedule",
          url: "/orders/shared-shipping?step=5&step=6&step=7&step=8",
          icon: "fas fa-shipping-fast"
        },
        {
          name: "Shared BL Copy",
          url: "/orders/sharedbl?step=6&step=7&step=8",
          icon: "fas fa-money-check-alt"
        },
        {
          name: "Sent Original Documents",
          url: "/orders/sent-docs?step=7&step=8",
          icon: "fas fa-file-signature"
        },
        {
          name: "Car Received",
          url: "/orders/car-received?step=8",
          icon: "fas fa-car"
        }
      ]
    },
    {
      name: "Testimonials",
      url: "/testimonials",
      icon: "fas fa-smile"
    },
    {
      name: "Billing",
      url: "/billing",
      icon: "fas fa-dollar-sign"
    },
    {
      name: "Freight",
      url: "/freight",
      icon: "fas fa-truck-loading"
    },
    {
      name: "Macros",
      url: "/macros",
      icon: "fas fa-file"
    },
    {
      name: "System Guidelines",
      url: "/system-guidelines",
      icon: "fab fa-guilded"
    }
  ]
};

const prettyText = text => {
  if (!text) return "";
  text = _.toLower(text);
  return text
    .split("_")
    .map(o => o.charAt(0).toUpperCase() + o.slice(1))
    .join(" ");
};

const swapPretty = (json, noPretty) => {
  var ret = {};
  for (var key in json) {
    ret[json[key]] = noPretty ? key : prettyText(key);
  }
  return ret;
};

export const driveTypes = swapPretty(
  {
    "2WD": 1,
    "4WD": 2,
    ALL: 3,
    "2": 1,
    "4": 2
  },
  true
);

export const steeringTypes = swapPretty({
  LEFT: 1,
  RIGHT: 2,
  OTHER: 4
});

export const bodyTypes = swapPretty({
  BUS_MINIBUS: 10,
  BIKE: 20,
  CONVERTIBLE: 6,
  COUPE: 5,
  HATCHBACK: 1,
  MACHINERY: 11,
  MINI_VEHICLE: 12,
  PICKUP_TRUCK: 14,
  SEDAN: 2,
  SUV: 3,
  TRUCK: 9,
  UTE: 8,
  VAN_MINIVAN: 7,
  WAGON: 4,
  OTHER: 13
});

export const fuelTypes = swapPretty({
  BIODIESEL: 1,
  CNG: 2,
  DIESEL: 3,
  ELECTRIC: 4,
  ETHANOL: 5,
  GASOLINE_PETROL: 6,
  "GASOLINE/PETROL": 6,
  GASOLINE: 6,
  PETROL: 6,
  HYBRID: 7,
  LPG: 8,
  STEAM: 9,
  OTHER: 10
});

export const colorTypes = swapPretty({
  BEIGE: 1,
  BLACK: 2,
  BLUE: 3,
  BRONZE: 4,
  BROWN: 5,
  BURGUNDY: 6,
  CHAMPAGNE: 7,
  CHARCOAL: 8,
  CREAM: 9,
  DARK_BLUE: 10,
  DARK_GREEN: 11,
  GOLD: 12,
  GRAY: 13,
  GREEN: 14,
  IVORY: 15,
  LIGHT_BLUE: 16,
  MAROON: 17,
  OFF_WHITE: 18,
  ORANGE: 19,
  OTHER: 20,
  PEARL: 21,
  PEWTER: 22,
  PINK: 23,
  PURPLE: 24,
  RED: 25,
  SILVER: 26,
  TAN: 32,
  TEAL: 33,
  TITANIUM: 27,
  TURQUOISE: 28,
  WHITE: 29,
  WINE_RED: 30,
  YELLOW: 31,
  GUN_METALLIC: 32
});

export const transmissionTypes = swapPretty({
  AUTOMATIC: 1,
  MANUAL: 2,
  OTHER: 4
});

const zendeskFields = {
  ETA: 24784383,
  ETD: 24843046,
  vesselName: 24784403,
  trackingNo: 24843066,
  courierService: 24784423
};

const zendeskFieldsProd = {
  ETA: 24356019,
  ETD: 24349629,
  vesselName: 28602162,
  trackingNo: 24469275,
  courierService: 24186286
};

export default {
  local: {
    frontURI: "http://localhost:3000",
    graphql_uri: "/graphql",
    server_stack_url: "http://localhost:8888/api/v3/graphql",
    server_stack_bucket: "http://192.168.1.57:4566/cfj-bucket-dev",
    server_stack_upload: "http://localhost:8888/api/v3/upload",
    server_stack_upload_base64: "http://localhost:8888/api/v3/image/base64",
    cdnURI: "http://localhost:3000",
    tinymce_upload_url: "http://localhost:3000/api/site/upload",
    zendeskFields,
    gtmId: "GTM-M8FJ473"
  },
  development: {
    frontURI: "https://dev.carfromjapan.com",
    graphql_uri: "https://dev.carfromjapan.com/graphql",
    server_stack_url: "https://dev.carfromjapan.com/api/v3/graphql",
    server_stack_bucket: "//static-dev.carfromjapan.com",
    server_stack_upload: "https://dev.carfromjapan.com/api/v3/upload",
    server_stack_upload_base64: "https://dev.carfromjapan.com/api/v3/image/base64",
    cdnURI: "https://static-dev.carfromjapan.com",
    tinymce_upload_url: "https://dev.carfromjapan.com/api/site/upload",
    zendeskFields,
    gtmId: "GTM-M8FJ473"
  },
  staging: {
    frontURI: "https://staging.carfromjapan.com",
    graphql_uri: "https://staging.carfromjapan.com/graphql",
    server_stack_url: "https://staging.carfromjapan.com/api/v3/graphql",
    server_stack_bucket: "//static.carfromjapan.com",
    server_stack_upload: "https://staging.carfromjapan.com/api/v3/upload",
    server_stack_upload_base64: "https://staging.carfromjapan.com/api/v3/image/base64",
    cdnURI: "https://static.carfromjapan.com",
    tinymce_upload_url: "https://carfromjapan.com/api/site/upload",
    zendeskFields,
    gtmId: "GTM-KVMRCLX"
  },
  production: {
    frontURI: "https://carfromjapan.com",
    graphql_uri: "https://carfromjapan.com/graphql",
    server_stack_url: "https://carfromjapan.com/api/v3/graphql",
    server_stack_bucket: "//static.carfromjapan.com",
    server_stack_upload: "https://carfromjapan.com/api/v3/upload",
    server_stack_upload_base64: "https://carfromjapan.com/api/v3/image/base64",
    cdnURI: "https://static.carfromjapan.com",
    tinymce_upload_url: "https://carfromjapan.com/api/site/upload",
    zendeskFields: zendeskFieldsProd,
    gtmId: "GTM-KVMRCLX"
  }
}[ENV];
